import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa";
import "./styles.css";
import { styled } from "@mui/material/styles";
import { icons } from "../../constants";

const BreadCrumbComp = ({ personalized, data }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.split("/").filter((x) => x);

  const pathnames = path.splice(0, path.length);

  const BreadcrumbsStyled = styled(Breadcrumbs)(({ theme }) => ({
    margin: "35px 0",
  }));

  const breadcrumbNameMap = {
    "/dashboard": "Contexto de la Organización",
    "/self_appraisal/survey": personalized,
    "/superior_rol_dashboard": "Dashboard",
    "/dashboard/dofa/processDetails": "Detalles del Proceso",
    "/clients": "Clientes",
    "/gestion_HSQ_GCD": "Gestión HSQ GCD",
    "/gestion_HSQ_GCD/interestedParties": "Partes Interesadas",
    "/interestedParties/interestedPartiesExternal":
      "Partes Interesadas Externas",
    "/clients/topClients": "Listado de Clientes",
    "/clients/topProducts": "Listado de Productos",
    "/clients/topProducts/details": "Detalle del Producto",
    "/self_appraisal": "Evaluación",
    "/360_Report": "Informe 360°",
    "/superior_rol_dashboard/Pai_360": "PAI 360°",
    "/biomedicalManagementDashboard": "Dashboard",
    "/biomedicalManagementDashboard/biomedicalAdminPage":
      "Administración biomédica",
    "/biomedicalManagementDashboard/catalogAdmin": "Administración biomédica",
    "/biomedicalManagementDashboard/indicator":
      " Indicador de Cumplimiendo de Orden de Servicio",
    "/biomedicalManagementDashboard/BioMedicalRequest": "Orden de Servicio",
    "/biomedicalManagementDashboard/BioMedicalRequest/createRequest":
      "Ficha Orden de Servicio",
    "/riskAndOpportunityManagement": "Gestión de Riesgos y Oportunidades",
    "/dashboard/dofa": "DOFA",
    "/riskAndOpportunityManagement/dofa": "DOFA",
    "/riskAndOpportunityManagement/riskAdminGestion": personalized,
    "/riskAndOpportunityManagement/riskAdminGestion/riskDetails":
      "Detalles del Riesgo",
    "/riskAndOpportunityManagement/opportunityAdminGestion": personalized,
    "/riskAndOpportunityManagement/opportunityAdminGestion/opportunityDetails":
      "Detalles del Oportunidad",
    "/riskAndOpportunityManagement/createRisk": "Nuevo Riesgo",
    "/riskAndOpportunityManagement/createOpportunity": "Nueva Oportunidad",
    "/biomedicalManagementDashboard/manageDevice":
      "Inventario de equipos biomédicos",
    "/biomedicalManagementDashboard/manageDevice/registerBiomedicalEquipment":
      "Alta Dispositivo",
    "/biomedicalManagementDashboard/manageDevice/NewTechnicalInspectionAct":
      "Nueva Acta de Inspección Técnica",
    "/biomedicalManagementDashboard/manageDevice/BiomedicalEquipmentResume":
      "Hoja de Vida Equipo Biomédico",
    "/management_direction": "Gestión de la Dirección",
    "/management_direction/banner_admin": "Administración Banner",
    "/marketingPromotionManagement": "Gestión Mercadeo y Promoción GMP",
    "/marketingPromotionManagement/accompaniment_Module":
      "Módulo de Acompañamiento",
    "/marketingPromotionManagement/accompaniment_Module/accompaniment":
      "Acompañamiento y mejora del equipo comercial",
    "/marketingPromotionManagement/accompaniment_Module/accompanimentPreview":
      "Acompañamiento y mejora del equipo comercial",
    "/biomedicalManagementDashboard/serviceRecords": "Reporte de Ingeniería",
    "/biomedicalManagementDashboard/serviceRecords/createEngineeringReport":
      "Nuevo Reporte de Ingeniería",
    "/suppliers": "Proveedores",
    "/suppliers/suppliers_national": "Proveedor Farmacéutico Nacional ",
    "/suppliers/international_suppliers":
      "Proveedor Farmacéutico Internacional ",
    "/suppliers/services_suppliers": "Proveedor de Servicios",
    "/suppliers/suppliers_national/create_new":
      "Crear Nuevo Proveedor Farmacéutico Nacional",
    "/suppliers/international_suppliers/create_new":
      "Crear Nuevo Proveedor Farmacéutico Internacional",
    "/suppliers/services_suppliers/create_new":
      "Crear Nuevo Proveedor de Servicios",
    "/interestedParties/detailInternalStakeholders":
      "Partes Interesadas Internas",
    "/requirements": "Requerimientos",
    "/interestedPartiesGraph": "Partes Interesadas",
    "/gestion_HSQ_GCD/interestedParties/interestedPartiesProcessDetail/create":
      "Crear Parte interesada",
    "/gestion_HSQ_GCD/interestedParties/interestedPartiesProcessDetail":
      personalized,
    "/manage_time": "Actividades",
    "/manage_time/justified_activities": "Actividades justificadas",
    "/wallet": "Gestión Financiera y Contable GFC",
    "/wallet/products": "Productos Cartera",
    "/foreign_trade_board": "Dashboard Comercio Exterior",
    "/foreign_trade_board/nationalization_Time": "Tiempo de Nacionalizacion",
    "/foreign_trade_board/nationalization_Time/create_import": "Crear Importación",
    "/foreign_trade_board/internal_client_satisfaction": "Satisfacción Cliente Interno",
    "/foreign_trade_board/internal_client_satisfaction/create": "Crear Encuesta Satisfacción Cliente Interno",
    "/foreign_trade_board/internal_client_satisfaction/answer": "Encuesta",
    "/foreign_trade_board/internal_client_satisfaction/answer/:token": "Responder Encuesta Satisfacción Cliente Interno",
    "/foreign_trade_board/internal_client_satisfaction/national/answer/:surveyOrderId": "Encuesta Cliente Internacional",
    "/foreign_trade_board/internal_client_satisfaction/view/:answerId": "Ver Resultados de Encuesta",
    "/foreign_trade_board/external_client_satisfaction": "Satisfacción Cliente Internacional",
    "/foreign_trade_board/external_client_satisfaction/create": "Crear Encuesta Satisfacción Cliente Internacional",
    "/foreign_trade_board/external_client_satisfaction/international/answer/:surveyOrderId": "Encuesta Cliente Internacional",
    "/wallet/collection": "Cartera por Factura",
    "/foreign_trade_board/importExecution": "Ejecución de Importaciones",
    "/foreign_trade_board/importExecution/addAnnualProjectionModal": "Crear Proyección Anual 2026",
    "/foreign_trade_board/import_registration": "Registro de Importación"
  };

  const handleNavigate = (to) => {
    if (
      data &&
      to === "/gestion_HSQ_GCD/interestedParties/interestedPartiesProcessDetail"
    ) {
      navigate(to, { state: { rowData: data } });
    } else {
      navigate(to);
    }
  };

  return (
    <div className="no-print">
      <BreadcrumbsStyled separator={<FaAngleRight />} aria-label="breadcrumb">
        <Link to="/">
          <img
            className="btn-icon"
            src={icons.homeGray}
            alt="icon"
            style={{ marginRight: "10px" }}
          />
        </Link>
        {pathnames.length === 1 && pathnames[0] === "360_Report" && (
          <Link to="/superior_rol_dashboard" className="breadcrums_off_text">
            Dashboard
          </Link>
        )}
        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;

          return last ? (
            <p className="breadcrums_text" key={to}>
              {breadcrumbNameMap[to]}
            </p>
          ) : (
            <p
              key={to}
              className="breadcrums_off_text"
              style={{ cursor: "pointer" }}
              onClick={() => handleNavigate(to)}
            >
              {breadcrumbNameMap[to]}
            </p>
          );
        })}
      </BreadcrumbsStyled>
    </div>
  );
};

export default BreadCrumbComp;
